import { cva as e } from "@/styled-system/css";
const n = e({
  base: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "absolute",
    inset: "0",
    zIndex: 2
  }
});
export {
  n as buttonLoadingRecipe
};
//# sourceMappingURL=button-loading.styles.js.map
